import {
  FETCH_SMS_USER,
  FETCH_SMS_HISTORY,
  LOAD_SMS_USER,
  LOAD_SMS_HISTORY,
  FETCH_SMS_DETAILS,
  FETCH_SMS_MEMBERS_SUBSCRIBED,
  FETCH_SMS_MEMBERS_UNSUBSCRIBED,
  LOAD_SMS_DETAILS,
  LOAD_SMS_MEMBERS_SUBSCRIBED,
  LOAD_SMS_MEMBERS_UNSUBSCRIBED,
  RESET_SMS_DETAILS,
  RESET_SMS_MEMBERS_SUBSCRIBED,
  RESET_SMS_MEMBERS_UNSUBSCRIBED
} from '../Actions/Sms'

const emptySmsData = {
  title: '',
  status: '',
  timestamp: ''
}

const initialState = {
  user: { title: 'Loading' },
  history: [emptySmsData],
  smsHistoryLength: 0,
  smsDetails: {
    title: 'Loading'
  },
  smsMembersSubscribed: {
    title: 'Loading'
  },
  smsMembersUnsubscribed: {
    title: 'Loading'
  }
}

/**
 * NotificationReducer
 * @desc reducer that handles data displayed on the Notifications page
 * @param {Object} state
 * @param {action} action
 * @return {Object} state updated state
 */
export default function SmsReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_SMS_DETAILS:
      return Object.assign({}, state, { smsDetails: { title: 'Loading' } })
    case LOAD_SMS_DETAILS:
      return Object.assign({}, state, { smsDetails: action.data.getSmsDetails })
    case FETCH_SMS_MEMBERS_SUBSCRIBED:
      return Object.assign({}, state, { smsMembersSubscribed: { title: 'Loading' } })
    case FETCH_SMS_MEMBERS_UNSUBSCRIBED:
      return Object.assign({}, state, { smsMembersUnsubscribed: { title: 'Loading' } })
    case LOAD_SMS_MEMBERS_SUBSCRIBED:
      return Object.assign({}, state, { smsMembersSubscribed: action.data.getSmsMembers })
    case LOAD_SMS_MEMBERS_UNSUBSCRIBED:
      return Object.assign({}, state, { smsMembersUnsubscribed: action.data.getSmsMembers })
    case FETCH_SMS_USER:
      return Object.assign({}, state, { user: { title: 'Loading' } })
    case LOAD_SMS_USER:
      return Object.assign({}, state, { user: action.data.getSmsUser })
    case FETCH_SMS_HISTORY:
      return Object.assign({}, state, { history: [Object.assign({}, emptySmsData, { title: 'Loading' })], smsHistoryLength: 0 })
    case LOAD_SMS_HISTORY:
      return Object.assign({}, state, { history: action.data.getSmsHistory.smsData, smsHistoryLength: action.data.getSmsHistory.count })
    case RESET_SMS_DETAILS:
      return Object.assign({}, state, { smsDetails: { title: 'Loading' } })
    case RESET_SMS_MEMBERS_SUBSCRIBED:
      return Object.assign({}, state, { smsMembersSubscribed: { title: 'Loading' } })
    case RESET_SMS_MEMBERS_UNSUBSCRIBED:
      return Object.assign({}, state, { smsMembersUnsubscribed: { title: 'Loading' } })
    default:
      return state
  }
}
